import type { ThemeColors } from '../components/PDFDocument';

/**
 * Get actual color value from CSS custom property
 */
const getCSSVar = (varName: string): string => {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(varName)
    .trim();

  if (!value) {
    console.warn(`CSS variable ${varName} not found, using fallback`);
  }

  return value || '#000000'; // Fallback to black if not found
};

/**
 * Extract theme colors from QwickApps CSS custom properties
 * for use in PDF generation (which can't use CSS variables)
 */
export const getThemeColors = (): ThemeColors => {
  return {
    primary: getCSSVar('--theme-primary'),
    secondary: getCSSVar('--theme-secondary'),
    textPrimary: getCSSVar('--theme-text') || getCSSVar('--theme-on-background'),
    textSecondary: getCSSVar('--theme-text-secondary'),
    background: getCSSVar('--theme-background') || getCSSVar('--theme-surface'),
    divider: getCSSVar('--theme-divider') || getCSSVar('--theme-border'),
  };
};
